import { waitForElm } from "./waitForElm"

export const scrollToBottomContainer = async (id: string, delay: number) => {
  const container = (await waitForElm(id)) as HTMLDivElement
  let timer = setTimeout(() => {
    container.scrollTop = container.scrollHeight
  }, delay)
  return () => clearTimeout(timer)
}
